import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { pathname } = useLocation();
  const { user } = useAuth();
  const showFooterCta = !user && pathname !== '/auth' && pathname !== '/join' && pathname !== '/register-creator' && pathname !== '/account-deleted';

  return (
    <footer className={`site-footer${showFooterCta ? '' : ' auth-site-footer'}`}>
      {showFooterCta && <section className="footer-cta">
        <div className="footer-light-orbs" aria-hidden="true">
          <span className="footer-light-orb orb-pink" />
          <span className="footer-light-orb orb-blue" />
          <span className="footer-light-orb orb-gold" />
          <span className="footer-light-orb orb-violet" />
          <span className="footer-light-orb orb-cyan" />
        </div>
        <div className="footer-cta-content">
          <h2>Ready for your next night out?</h2>
          <p>Book an event in <strong>3</strong> steps. Scan <strong>QRs</strong> at the door. Use your<br className="footer-cta-break" /> <strong>Ticket Codes</strong> and check them in.</p>
          <div className="footer-cta-buttons">
            <Link to="/browse" className="footer-cta-button primary">Book Events</Link>
            <Link to="/join" className="footer-cta-button secondary">Join Now</Link>
          </div>
        </div>
      </section>}
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src="/assets/images/Tickets.gif" alt="Tickets Lord" className="footer-logo-img" />
              <span className="footer-logo-text">Tickets Lord</span>
            </Link>
            <p className="footer-description">
              Your premier destination for event tickets. Book tickets for concerts, sports, theater, and more.
            </p>
          </div>
          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/browse">Browse Events</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/support">Support</Link></li>
            </ul>
          </div>
          <div className="footer-links">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/terms">Terms & Conditions</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/cookie-policy">Cookie Policy</Link></li>
              <li><Link to="/acceptable-use-policy">Acceptable Use Policy</Link></li>
            </ul>
          </div>
          <div className="footer-contact">
            <h4>Contact</h4>
            <ul>
              <li>Email:<br />support@ticketslord.com</li>
              <li>Support: 24/7 Available</li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {currentYear} Tickets Lord. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
